import { memo } from "react";
import { UpdateChargeVesselTablePanel } from "./Table/UpdateChargeVesselTablePanel";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";

const UpdateChargeVesselContent = ({ chargeDetailState, updateStatusType }:
        { chargeDetailState: ChargeDetailModel, updateStatusType: string }) => {
        return <div className={`main-comp-wrapper`} style={{ width: "60vw", height: "69vh" }}>
                <UpdateChargeVesselTablePanel chargeDetailState={chargeDetailState} updateStatusType={updateStatusType} />
        </div>
}

export default memo(UpdateChargeVesselContent);